/**
 * Error describers for the comms surfaces — maps the server's
 * `{ error: code }` envelopes (announcements / shout-outs routes) to
 * copy the UI can toast or render inline. Mirrors the eos/errors.ts
 * convention.
 */

export function commsErrorCode(err: unknown): string | null {
  if (err && typeof err === 'object' && 'response' in err) {
    const response = (err as { response?: { data?: { error?: unknown } } }).response;
    const code = response?.data?.error;
    if (typeof code === 'string') return code;
  }
  return null;
}

/** The server's human-readable `message` field, when present. */
export function commsErrorMessage(err: unknown): string | null {
  if (err && typeof err === 'object' && 'response' in err) {
    const response = (err as { response?: { data?: { message?: unknown } } }).response;
    const message = response?.data?.message;
    if (typeof message === 'string') return message;
  }
  return null;
}

export function describeCommsError(err: unknown, fallback: string): string {
  const code = commsErrorCode(err);
  switch (code) {
    case 'forbidden':
      return commsErrorMessage(err) ?? "You don't have permission for that.";
    case 'validation_failed':
      return 'Some fields look invalid — double-check and retry.';
    case 'announcement_not_found':
      return 'That announcement no longer exists — refresh the page.';
    case 'department_not_found':
      return 'That department no longer exists.';
    case 'ack_not_required':
      return 'This announcement does not require acknowledgment.';
    case 'cannot_shout_out_self':
      return "You can't give yourself a shout-out.";
    case 'recipient_not_found':
      return 'That person is not an active member of this organization.';
    case 'no_core_values_defined':
      return 'Define your core values on the V/TO first.';
    case 'core_value_not_recognized':
      return "That core value isn't on the current V/TO — pick one of the chips.";
    case 'shout_out_not_found':
      return 'That shout-out no longer exists — refresh the page.';
    default:
      return err instanceof Error ? err.message : fallback;
  }
}
